import Product_1 from "../Assets/Products/product_1.jpg";
import Product_1_1 from "../Assets/Products/product_1-1.jpg";
import Product_2 from "../Assets/Products/product_2.jpg";
import Product_2_1 from "../Assets/Products/product_2-1.jpg";
import Product_3 from "../Assets/Products/product_3.jpg";
import Product_3_1 from "../Assets/Products/product_3-1.jpg";
import Product_4 from "../Assets/Products/product_4.jpg";
import Product_4_1 from "../Assets/Products/product_4-1.jpg";
import Product_5 from "../Assets/Products/product_5.jpg";
import Product_5_1 from "../Assets/Products/product_5-1.jpg";
import Product_6 from "../Assets/Products/product_6.jpg";
import Product_6_1 from "../Assets/Products/product_6-1.jpg";
import Product_7 from "../Assets/Products/product_7.jpg";
import Product_7_1 from "../Assets/Products/product_7-1.jpg";
import Product_8 from "../Assets/Products/product_8.jpg";
import Product_8_1 from "../Assets/Products/product_8-1.jpg";
import Product_9 from "../Assets/Products/product_3_3.jpg";

import limited1 from "../Assets/LimitedEdition/limited-1.jpg";
import limited2 from "../Assets/LimitedEdition/limited-2.jpg";
import limited3 from "../Assets/LimitedEdition/limited-3.jpg";
import limited4 from "../Assets/LimitedEdition/limited-4.jpg";
import limited5 from "../Assets/LimitedEdition/limited-5.jpg";

let StoreData = [
  {
    productID: 1,
    frontImg: Product_1,
    productName: "Moonlit Majesty Ring",
    productReviews: "Featured",
    stars: 3,
    category: "Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F", // F for Featured
    sku: "Made to Order",
    tags: ["Modern", "Minimalist", "Statement"],
  },
  {
    productID: 2,
    frontImg: Product_2,
    productName: "Celestial Charm Bracelet",
    productReviews: "Featured",
    stars: 3.5,
    category: "Bracelet",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    sku: "Made to Order",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 3,
    frontImg: Product_3,
    backImg: Product_3,
    productName: "Ethereal Blossom Necklace",
    isOnSale: true, // Explicit sale flag
    productPrice: 6000,
    originalPrice: 120, // Added original price
    discountPercent: 50, // Added specific discount
    productReviews: "Sale",
    stars: 3,
    category: "Necklace",
    metalType: "925 Silver",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "S", // Changed to S for Sale
    tags: ["Floral", "Delicate", "Modern"],
  },
  {
    productID: 4,
    frontImg: Product_4,
    productName: "Serenity Silver Band",
    productReviews: "Featured",
    stars: 3,
    category: "Jhumke",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Minimalist", "Modern", "Casual"],
  },
  {
    productID: 5,
    frontImg: Product_5,
    productName: "Enchanted Ivy Bangle",
    productReviews: "Featured",
    stars: 3,
    category: "Pendants",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Floral", "Statement", "Ornate"],
  },
  {
    productID: 6,
    frontImg: Product_6,
    productName: "Starlit Cascade Earrings",
    productPrice: 12222,
    productReviews: "1k+ reviews",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "925 Silver",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Delicate"],
  },
  {
    productID: 7,
    frontImg: Product_7,
    productName: "Twilight Empress Necklace",
    productPrice: 99,
    productReviews: "Featured",
    stars: 3,
    category: "Necklace",
    metalType: "925 Silver",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Ornate", "Statement", "Formal"],
  },
  {
    productID: 8,
    frontImg: Product_8,
    productName: "Lustrous Pearl Choker",
    productReviews: "4k+ reviews",
    stars: 3,
    category: "Bridal Sets",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Classic", "Formal", "Ornate"],
  },
  {
    productID: 9,
    frontImg: Product_9,
    productName: "Radiance Halo Pendant",
    productPrice: 29,
    productReviews: "8k+ reviews",
    stars: 4,
    category: "Pendants",
    metalType: "925 Silver",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 10,
    frontImg: limited2,
    productName: "Golden Aurora Cuff",
    productReviews: "5k+ reviews",
    stars: 3,
    category: "Men - Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 11,
    frontImg: limited3,
    productName: "Opulent Gleam Anklet",
    productReviews: "1k+ reviews",
    stars: 3,
    category: "Anklet",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Delicate", "Modern", "Casual"],
  },
  {
    productID: 12,
    frontImg: limited4,
    productName: "Iridescent Grace Ring",
    productReviews: "Bestseller",
    stars: 3,
    category: "Engagement Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "B",
    tags: ["Classic", "Formal", "Ornate"],
  },
  {
    productID: 13,
    frontImg: limited5,
    productName: "Majestic Noir Bracelet",
    productReviews: "71+ reviews",
    stars: 3,
    category: "Chains",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 14,
    frontImg: limited5,
    productName: "Royal Empress Bangle",
    productReviews: "2k+ reviews",
    stars: 3,
    category: "Bangles",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Ornate", "Statement", "Formal"],
  },
  {
    productID: 15,
    frontImg: limited5,
    productName: "Midnight Glimmer Necklace",
    productReviews: "6k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Delicate"],
  },
  {
    productID: 16,
    frontImg: limited5,
    productName: "Twilight Sparkle Ring",
    productReviews: "3k+ reviews",
    stars: 3,
    category: "Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 17,
    frontImg: limited5,
    productName: "Golden Mirage Earrings",
    productReviews: "1.5k+ reviews",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 18,
    frontImg: limited5,
    productName: "Mystic Sapphire Choker",
    productReviews: "4k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Classic", "Formal", "Ornate"],
  },
  {
    productID: 19,
    frontImg: limited5,
    productName: "Velvet Moon Pendant",
    productReviews: "2.8k+ reviews",
    stars: 3,
    category: "Pendants",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 20,
    frontImg: limited5,
    productName: "Seraphic Halo Earrings",
    productReviews: "5k+ reviews",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 21,
    frontImg: Product_1,
    productName: "Celestial Glow Ring",
    productReviews: "6k+ reviews",
    stars: 3,
    category: "Bangles",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 22,
    frontImg: Product_2,
    productName: "Eclipse Charm Bracelet",
    productReviews: "3k+ reviews",
    stars: 3,
    category: "Bracelet",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 23,
    frontImg: Product_3,
    productName: "Ethereal Starlight Necklace",
    productReviews: "5k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 24,
    frontImg: Product_4,
    productName: "Gleaming Horizon Band",
    productReviews: "4k+ reviews",
    stars: 3,
    category: "Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Minimalist", "Modern", "Casual"],
  },
  {
    productID: 25,
    frontImg: Product_5,
    productName: "Regal Opal Bangle",
    productReviews: "10k+ reviews",
    stars: 3,
    category: "Bangles",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Ornate", "Statement", "Formal"],
  },
  {
    productID: 26,
    frontImg: Product_6,
    productName: "Sunbeam Cascade Earrings",
    productReviews: "2k+ reviews",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Delicate"],
  },
  {
    productID: 27,
    frontImg: Product_7,
    productName: "Silver Twilight Necklace",
    productReviews: "4k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 28,
    frontImg: Product_8,
    productName: "Pearlescent Halo Choker",
    productReviews: "5k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Classic", "Formal", "Ornate"],
  },
  {
    productID: 29,
    frontImg: limited1,
    productName: "Golden Radiance Pendant",
    productReviews: "9k+ reviews",
    stars: 3,
    category: "Pendants",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "B",
    tags: ["Modern", "Statement", "Delicate"],
  },
  {
    productID: 30,
    frontImg: limited2,
    productName: "Aurora Gleam Cuff",
    productReviews: "6k+ reviews",
    stars: 3,
    category: "Bracelet",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 31,
    frontImg: limited3,
    productName: "Gilded Moon Anklet",
    productPrice: 28,
    originalPrice: 40,
    discountPercent: 30,
    productReviews: "Sale",
    stars: 3,
    category: "Anklet",
    metalType: "925 Silver",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "S",
    isOnSale: true,
    tags: ["Delicate", "Modern", "Casual"],
  },
  {
    productID: 32,
    frontImg: limited4,
    productName: "Luminous Dream Ring",
    productReviews: "8k+ reviews",
    stars: 3,
    category: "Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "B",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 33,
    frontImg: limited5,
    productName: "Nocturnal Glow Bracelet",
    productReviews: "72+ reviews",
    stars: 3,
    category: "Bracelet",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "B",
    tags: ["Modern", "Statement", "Geometric"],
  },
  {
    productID: 34,
    frontImg: limited5,
    productName: "Empress Luxe Bangle",
    productReviews: "3k+ reviews",
    stars: 3,
    category: "Bangles",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "B",
    tags: ["Ornate", "Statement", "Formal"],
  },
  {
    productID: 35,
    frontImg: limited5,
    productName: "Moonlit Whisper Necklace",
    productReviews: "7k+ reviews",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 36,
    frontImg: limited5,
    productName: "Dusky Shine Ring",
    productReviews: "4k+ reviews",
    stars: 3,
    category: "Rings",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 37,
    frontImg: limited5,
    productName: "Golden Aura Earrings",
    productReviews: "Featured",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 38,
    frontImg: limited5,
    productName: "Mystic Gem Choker",
    productReviews: "Featured",
    stars: 3,
    category: "Necklace",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 39,
    frontImg: limited5,
    productName: "Velvet Sun Pendant",
    productReviews: "Featured",
    stars: 3,
    category: "Pendants",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
  {
    productID: 40,
    frontImg: limited5,
    productName: "Celestial Hoop Earrings",
    productReviews: "Featured",
    stars: 3,
    category: "Earrings & Tops",
    metalType: "Gold",
    size: "M",
    brand: "Hussain Sons",
    productCategory: "F",
    tags: ["Modern", "Delicate", "Statement"],
  },
];

export default StoreData;
